export default __webpack_public_path__ + "static/media/powered_by_stripe.ec119bb6.svg";